import { getGlobalEventsLogs } from '@cian/events-log';
import { TThunkAction } from '../../types/redux';
import { subscribeOnAuthentification } from './authenticationUtils';
import { IRequestAuthenticationParameters, IAuthenticateEvent, TOPIC_USER } from './types';

export function requestAuthentication(parameters?: IRequestAuthenticationParameters): TThunkAction {
  return dispatch => {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
      const globalLog = getGlobalEventsLogs();

      dispatch(subscribeOnAuthentification(parameters));

      globalLog.produce<Required<IAuthenticateEvent>>(TOPIC_USER, {
        type: 'authenticate',
        value: {
          autoRefresh: false,
          viewData: parameters?.viewData || null,
          source: parameters?.source || null,
        },
      });
    }
  };
}
